import { Pipe, PipeTransform } from '@angular/core';
/**
 * could be applied for any object having ative property
 */
@Pipe({
  name: 'filterActive'
})
export class FilterActivePipe implements PipeTransform {
  transform<T extends { active: boolean }>(items: T[]): T[] {
    return items.filter(item => item.active);
  }
}
